/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import UsersList from "../../Modals/usersList";
import React from "react";
import { ADMIN_NOTIFICATION_TYPE, ADMIN_NOTIFICATION_TYPE_NAME } from "../../utils/enums";
import DeleteConfirmModal from "../../Modals/deleteConfirmModal";
import IfCan from "../../components/IfCan";

type NotificationRow = {
  id: number;
  title: string;
  message: string;
  notification_type?: number | string;
  created_at?: string;
  users?: string; // comma-separated ids from API
};

type NotificationsListProps = {
  rows: NotificationRow[];
  isLoading?: boolean;
  handleDelete: () => void | Promise<void>;
  setSelectedId?: React.Dispatch<React.SetStateAction<number | null>>;
};

const NotificationsList: React.FC<NotificationsListProps> = ({ rows, isLoading = false, handleDelete, setSelectedId }) => {

  const usersList = [
    { id: "1", label: "John Doe", avatar: "/static/images/user_placeholder.png" },
    { id: "2", label: "Jane Smith", avatar: "/static/images/user_placeholder.png" },
    { id: "3", label: "Michael Scott", avatar: "/static/images/user_placeholder.png" },
    { id: "4", label: "Pam Beesly", avatar: "/static/images/user_placeholder.png" },
  ];

  const getUserLabel = (userIdsCsv?: string) => {
    const ids = (userIdsCsv || "")
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean);
    if (ids.length === 0) return "-";
    return ids.length === 1 ? "1 User" : `${ids.length} Users`;
  };

  const [openUserModal, setOpenUserModal] = React.useState(false);
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [selectedUserIds, setSelectedUserIds] = React.useState<string[]>([]);

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Title</TableCell>
              <TableCell>Message</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Users</TableCell>
              <TableCell>Created Date</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!isLoading && rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">No data available</TableCell>
              </TableRow>
            ) : (
              rows.map((row) => (
                <TableRow hover key={row.id}>
                  <TableCell>{row.title}</TableCell>
                  <TableCell>{row.message}</TableCell>
                  <TableCell>
                    {typeof row.notification_type === "number"
                      ? ADMIN_NOTIFICATION_TYPE_NAME[row.notification_type] || "-"
                      : row.notification_type === String(ADMIN_NOTIFICATION_TYPE.EMAIL)
                        ? ADMIN_NOTIFICATION_TYPE_NAME[ADMIN_NOTIFICATION_TYPE.EMAIL]
                        : row.notification_type === String(ADMIN_NOTIFICATION_TYPE.BROADCAST)
                          ? ADMIN_NOTIFICATION_TYPE_NAME[ADMIN_NOTIFICATION_TYPE.BROADCAST]
                          : "-"}
                  </TableCell>
                  <TableCell className="click_action" onClick={() => { setSelectedUserIds((row.users || "").split(",").map((id) => id.trim()).filter(Boolean)); setOpenUserModal(true); }}>{getUserLabel(row.users)}</TableCell>
                  <TableCell>{row.created_at ? new Date(row.created_at).toLocaleDateString() : "-"}</TableCell>
                  <TableCell>
                    <Box className="table_actions v2">
                      <IfCan module="Notification Management" action="delete">
                        <IconButton onClick={() => {
                          if (setSelectedId) setSelectedId(row.id);
                          setDeleteOpen(true);
                        }}>
                          <img src="/static/images/trash2_icon.svg" alt="delete" />
                        </IconButton>
                      </IfCan>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <IfCan module="Notification Management" action="delete">
        <DeleteConfirmModal
          open={deleteOpen}
          setOpen={setDeleteOpen}
          handleDelete={handleDelete}
          title="Are you sure you want to delete this Notification?"
          message="This action cannot be undone."
        />
      </IfCan>
      <UsersList
        open={openUserModal}
        onClose={() => setOpenUserModal(false)}
        setOpen={setOpenUserModal}
        userIds={selectedUserIds}
        usersList={usersList}
      />
    </>
  );
};

export default NotificationsList;
